<template>
  <div class="rj-page-card">
    <div class="title">
      详细信息
    </div>
    <div class="search-box-line">
      <el-button
        type="primary"
        :loading="isExporting"
        @click="handleExportDetail"
      >
        详情导出
      </el-button>
      <el-upload
        :disabled="isImporting"
        class="upload-demo"
        action=""
        :http-request="handleImportInfo"
        :show-file-list="false"
      >
        <el-button :loading="isImporting">
          批量导入
        </el-button>
      </el-upload>

      <el-link
        v-if="isAdvance"
        type="text"
        href="/提前审批导入模板（共识客期+建议交期）.xlsx"
        class="link-color"
      >
        导入模板下载
      </el-link>
      <el-link
        v-if="isDelay"
        type="text"
        href="/延期审批导入模板（共识客期）.xlsx"
        class="link-color"
      >
        导入模板下载
      </el-link>
      <div class="tips">
        <i class="el-icon-warning-outline" />
        <div v-if="isAdvance">
          批量导入建议交期与共识客期
        </div>
        <div v-if="isDelay">
          批量导入共识客期
        </div>
      </div>
    </div>

    <el-table
      ref="table"
      :data="productList"
      border
      max-height="400"
      show-summary
      :summary-method="handleGetTotal"
      highlight-current-row
      highlight-selection-row
    >
      <el-table-column label="序号" type="index" align="left" fixed="left" width="60" />
      <el-table-column
        prop="contractNum"
        label="合同编号"
        align="left"
        fixed="left"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="orderNum"
        label="订单编号"
        align="left"
        width="150"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="orderRowNum"
        label="订单行号"
        align="left"
        width="80"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="projectName"
        label="项目名称"
        align="left"
        width="158"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="productName"
        label="产品型号"
        sortable
        align="left"
        header-align="left"
        width="180"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="quantity"
        label="未发货总数量"
        align="left"
        width="120"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="settlementAmount"
        label="结算金额"
        align="left"
        width="90"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="settlementAmountCny"
        label="客期变更金额（人民币）"
        align="left"
        min-width="130"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="advanceFrequency"
        label="客期已提前次数"
        align="left"
        width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="delayFrequency"
        label="客期已延迟次数"
        align="left"
        width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        v-if="isProductCoordination"
        prop="isControlled"
        label="是否受控"
        align="left"
        min-width="120"
        show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <span>
            {{ row.isControlled ? '受控' : "其他" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ceddBefore"
        label="当前客期"
        sortable
        align="left"
        width="110"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      />
      <el-table-column
        prop="ceddAfter"
        label="申请变更客期"
        sortable
        align="left"
        width="150"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      />

      <el-table-column
        prop="changeDays"
        label="变更天数"
        align="left"
        width="80"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <template v-if="isAdvance">
        <el-table-column
          prop="rectificationDeliveryDate"
          label="整改后交期"
          align="left"
          width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />

        <el-table-column
          prop="suggestionDeliveryDate"
          label="建议交期"
          align="left"
          width="180"
          sortable
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
        <!--          <template v-slot="{ row }">-->
        <!--            <el-date-picker-->
        <!--              v-model="row.suggestionDeliveryDate"-->
        <!--              type="date"-->
        <!--              placeholder="选择日期"-->
        <!--              style="width: 100%"-->
        <!--              size="medium"-->
        <!--              :clearable="false"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--              @change="(changeDate) => handleSuggestionDeliveryDateChange(changeDate, row)"-->
        <!--            />-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <el-table-column
          prop="isMet"
          label="是否满足变更客期"
          align="left"
          width="160"
          sortabl
          show-overflow-tooltipe
          :formatter="(...reset) => formatterValue(...reset, 'yesOrNo')"
        />
        <el-table-column
          prop="consensusDate"
          label="共识变更客期"
          align="left"
          min-width="170"
          sortable
        >
          <template v-slot="{ row }">
            <el-date-picker
              v-model="row.consensusDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              size="medium"
              :clearable="false"
              :picker-options="{
                disabledDate: (currentDate) => disableDate(currentDate, row)
              }"
              @change="updateList(row)"
            />
          </template>
        </el-table-column>
      </template>

      <template v-if="isDelay">
        <el-table-column
          prop="firstRectificationDeliveryDate"
          label="首次维护的整改后交期"
          align="left"
          min-width="186"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />

        <el-table-column
          prop="rectificationDeliveryDate"
          label="整改后交期"
          align="left"
          min-width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />

        <el-table-column
          v-if="isProductCoordination"
          prop="consensusDate"
          label="共识变更客期"
          align="left"
          min-width="170"
          sortable
        >
          <template v-slot="{ row }">
            <el-date-picker
              v-model="row.consensusDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              size="medium"
              :clearable="false"
              :picker-options="{
                disabledDate: (currentDate) => disableDate(currentDate, row)
              }"
              @change="updateList(row)"
            />
          </template>
        </el-table-column>
      </template>

      <el-table-column
        v-if="isProductCoordination"
        prop="productCoordination"
        label="产品统筹"
        align="left"
        min-width="150"
        sortable
        show-overflow-tooltip
        :formatter="formatterValue"
      />
    </el-table>
  </div>
</template>
<script>
import { deepCopy, downloadBlobFile, formatterValue, getNum, numAdd } from '@/libs/util';
import dayjs from 'dayjs';
import {
  exportCeddChangeAhead,
  exportCeddChangeDelay,
  importCeddChangeAhead,
  importCeddChangeDelay,
  saveProductDtl
} from '@/API/international';
import Big from 'big.js';

export default {
  name: 'DetailedInformation',
  props: {
    // 变更类型
    changeType: {
      type: String,
      default: ''
    },
    // 申请单单号
    applicationId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      productList: [],
      isImporting: false, // 导入中
      isExporting: false // 导出中
    };
  },
  computed: {
    // 变更类型:提前,显示整改后交期、建议交期、是否满足交期 三列
    isAdvance () {
      return this.changeType === 'advance';
    },
    // 变更类型:延迟,显示首次维护的整改后交期、整改后交期 两列
    isDelay () {
      return this.changeType === 'delay';
    },
    // 当前登录人是不是产品供应统筹？
    isProductCoordination () {
      return this.$store.state.user.isSupplyCoordination;
    }
  },
  methods: {
    formatterValue,
    dayjs,
    // 设置默认表格数据
    setDefaultFormData (data) {
      this.productList = deepCopy(data);
    },
    // 设置默认表格数据
    getFormData (type) {
      try {
        this.productList.forEach((item, index) => {
          if (this.isAdvance && !item.suggestionDeliveryDate) {
            throw new Error(`第${index + 1}行建议交期不能为空`);
          }
          /**
           * 为什么去除校验请看
           * @see https://ruijie.feishu.cn/wiki/K8WSw3qadiWoXTkaFVgccoFYnoc?sheet=5e2208&range=MzE6MzE
           */
          if (type !== 'reject') {
            if (!item.consensusDate) {
              throw new Error(`第${index + 1}行共识变更客期不能为空`);
            }
          }
        });
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }
      return deepCopy(this.productList);
    },
    // 计算总价
    handleGetTotal (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        if (index !== 7) {
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = Big(
            getNum(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                return isNaN(value) ? prev : prev + curr;
              }, 0)
            )
          ).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    // 导出详情
    handleExportDetail () {
      if (this.isAdvance) {
        exportCeddChangeAhead(this.applicationId)
          .then((res) => {
            downloadBlobFile({
              fileName: decodeURIComponent(
                res.headers['content-disposition'].split('=')[1]
              ),
              type: 'application/octet-stream',
              content: res.data
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
      if (this.isDelay) {
        exportCeddChangeDelay(this.applicationId)
          .then((res) => {
            downloadBlobFile({
              fileName: decodeURIComponent(
                res.headers['content-disposition'].split('=')[1]
              ),
              type: 'application/octet-stream',
              content: res.data
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    // 导入 共识客期和建议交期 或 共识客期
    handleImportInfo ({ file }) {
      // 是否是xlsx文件, 模板就是这种类型 所以不用考虑别的类型
      if (
        ![
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ].includes(file.type)
      ) {
        this.$message.warning('请上传填写好的模板xlsx文件');
        return;
      }
      this.isImporting = true;
      const formData = new FormData();
      formData.append('file', file);

      // 更具类型的不同调用不同的接口

      this.isAdvance &&
        importCeddChangeAhead(this.applicationId, formData)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.setDefaultFormData(json.data);
              this.$message.success('导入成功');
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.isImporting = false;
          });

      this.isDelay &&
        importCeddChangeDelay(this.applicationId, formData)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.setDefaultFormData(json.data);
              this.$message.success('导入成功');
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.isImporting = false;
          });
    },
    handleSuggestionDeliveryDateChange (changeDate, row) {
    // 3.否：建议交期为空时。isMet ceddAfter
      if (!changeDate) {
        row.isMet = false;
        return;
      }
      // 1.是：建议交期<=申请变更客期
      // 2.否：建议交期>申请变更客期
      row.isMet = dayjs(changeDate).isBefore(row.ceddAfter) || dayjs(changeDate).isSame(row.ceddAfter);
      this.updateList(row);
    },
    updateList (row) {
      saveProductDtl(row)
        .then((resopnse) => {
          const { status, data } = resopnse.data;
          if (status === '200') {
            this.productList = data;
            let totalCny = 0;
            this.productList.forEach((item) => {
              totalCny = numAdd(getNum(item.settlementAmountCny), totalCny);
            });
            this.$emit('totalCny', totalCny);
          }
        })
        .catch(console.log);
    },
    // 禁用共识客期选择的日期
    disableDate (current, row) {
      const ceddDate = dayjs(row.ceddBefore).format('YYYY-MM-DD');
      if (this.isAdvance) {
        return dayjs(current).isAfter(dayjs(ceddDate));
      }
      if (this.isDelay) {
        return dayjs(current).isBefore(dayjs(ceddDate));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 12px;
}
.search-box-line {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 12px;
  .el-button {
    font-size: 14px;
    & + .el-button {
      margin-left: 0;
    }
  }
}
.rj-page-card {
  height: auto;
}
:deep(.el-input__inner) {
  font-size: 14px;
}
:deep(.el-table-column--selection) {
  > .cell {
    padding-left: 10px;
    padding-right: 10px;
  }
}
:deep(.el-table__footer-wrapper) {
  font-weight: 700;
  font-size: 14px;
  .el-table__cell {
    padding: 11.5px 0;
  }
}
.tips {
  background-color: #fdf9e9;
  color: #8f5317;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  padding: 4px 10px;
}

.tips i {
  font-size: 22px;
}

.link-color {
  color: #409efe;
}
</style>
